import { css } from 'emotion'
import { DANGER_COLOR } from 'constants/styleConstants'

export const ErrorMessageStyles = css`
  font-size: 0.75em;
  font-style: italic;
  color: ${DANGER_COLOR};
  transition: height 0.1s ease-in-out;
`
